import React, { CSSProperties, ReactNode } from 'react';
import './Grid.css';

export interface GridProps {
  columns?: number;
  columnWidths?: string[];
  gap?: string;
  rowGap?: string;
  columnGap?: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  alignItems?: 'start' | 'center' | 'end' | 'stretch';
  justifyItems?: 'start' | 'center' | 'end' | 'stretch';
}

const Grid: React.FC<GridProps> = ({
  columns = 2,
  columnWidths,
  gap = '8px',
  rowGap,
  columnGap,
  children,
  className = '',
  style = {},
  alignItems,
  justifyItems,
}) => {
  const getGridTemplateColumns = (): string => {
    if (columnWidths && columnWidths.length > 0) {
      return columnWidths.join(' ');
    }
    return `repeat(${columns}, 1fr)`;
  };

  const gridStyles: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: getGridTemplateColumns(),
    gap: gap,
    ...(rowGap && { rowGap }),
    ...(columnGap && { columnGap }),
    ...(alignItems && { alignItems }),
    ...(justifyItems && { justifyItems }),
    ...style,
  };

  return (
    <div className={`custom-grid ${className}`} style={gridStyles}>
      {children}
    </div>
  );
};

export default Grid;
